__turbopack_context__.v({
  "headerText": "GreetingUserSkeleton-module-scss-module__Wz8bMW__headerText",
  "icon": "GreetingUserSkeleton-module-scss-module__Wz8bMW__icon",
  "row": "GreetingUserSkeleton-module-scss-module__Wz8bMW__row",
  "text": "GreetingUserSkeleton-module-scss-module__Wz8bMW__text",
});
